import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import apiRoot from "../../../api/apiRoot";

const TypographyHeader = ({ currentProjectId }) => {
  const { clientid } = useParams();
  const [exportingFigma, setExportingFigma] = useState(false);
  const [exportFigmaStatus, setExportFigmaStatus] = useState("Export To Figma");

  // Set an active class for 1.5 seconds so that we can apply some css to have a cool animation of a checkbox
  useEffect(() => {
    const timerId = setInterval(() => {
      setExportFigmaStatus("Export To Figma");
    }, 1500);

    return () => {
      clearInterval(timerId);
    };
  }, [exportFigmaStatus]);

  const handleFigmaExport = async (e) => {
    setExportingFigma(true);
    e.preventDefault();
    let responseStatus;
    try {
      const response = await apiRoot.post("/exportTypographyToFigma", {
        tyopgraphyData: "Test",
        paletteName: "default",
      });
      responseStatus = "Success!";
    } catch {
      responseStatus = "Failed!";
    }
    setExportingFigma(false);
    setExportFigmaStatus(responseStatus);
  };

  function exportButtonBackgroundColor(status) {
    if (status === "Success!") {
      return "Green";
    } else if (status === "Failed!") {
      return "Red";
    } else {
      return "rgb(26, 61, 134)";
    }
  }

  function renderTypeFacesLink() {
    if (currentProjectId) {
      return (
        <Link to={`/themeeditor/${clientid}/typography/typefaces`} className="header-link-item">
          Typefaces
        </Link>
      );
    } else {
      return null;
    }
  }

  return (
    <div className="typography tertiary header">
      <div className="left-header-container">
        <Link to={`/themeeditor/${clientid}/typography/`} className="header-link-item">
          Import Fonts
        </Link>
        {renderTypeFacesLink()}
        <Link to={`/themeeditor/${clientid}/typography/sizes`} className="header-link-item">
          Type Sizes
        </Link>
      </div>
      <div className="middle-header-container">Default</div>
    </div>
  );
};

export default TypographyHeader;
